<div class="loading-screen-wrapper">
  <mdb-spinner spinnerType="small" spinnerColor="blue"></mdb-spinner>
</div>
